import LoadingView from "legacy/LoadingView"
import AvailabilitySummary from "legacy/manage/dashboard/AvailabilitySummary"
import DailyNotes from "legacy/manage/dashboard/DailyNotes"
import DashboardDatePicker from "legacy/manage/dashboard/DashboardDatePicker"
import SeasonProgress from "legacy/manage/dashboard/SeasonProgress"
import UnpaidAlert from "legacy/manage/dashboard/UnpaidAlert"
import PropTypes from "prop-types"
import React from "react"

class DashboardController extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
    }

    this.fetchData = this.fetchData.bind(this)
  }

  componentDidMount() {
    this.fetchData()
  }

  fetchData() {
    $.post(this.props.dataRoute, (data) => {
      this.setState({
        loading: false,
        ...data,
      })
    })
  }

  render() {
    if (this.state.loading) {
      return <LoadingView />
    } else {
      return (
        <div>
          <div className="paper-page" style={{ position: "relative" }}>
            {this.state.unpaidCount > 0 && (
              <UnpaidAlert
                unpaidCount={this.state.unpaidCount}
                unpaidRoute={`${this.state.todayRoute}?unpaid=true`}
                marinaSlug={this.state.marinaSlug}
              />
            )}
            <DashboardDatePicker
              marinaSlug={this.state.marinaSlug}
              baseNightRoute={this.state.baseNightRoute}
              todayRoute={this.state.todayRoute}
              waitlistRoute={this.state.waitlistRoute}
              night={this.state.night}
              arrivalsCount={this.state.arrivalsCount}
              departuresCount={this.state.departuresCount}
              tonightCount={this.state.tonightCount}
              waitlistsCount={this.state.waitlistsCount}
            />
            {this.state.openingDay && this.state.closingDay && (
              <SeasonProgress
                openingDay={this.state.openingDay}
                closingDay={this.state.closingDay}
                seasonPercentage={Number(this.state.seasonPercentage)}
              />
            )}
          </div>
          <div className="paper-page">
            <DailyNotes
              night={this.state.night}
              notes={this.state.notes}
              notesRoute={this.state.notesRoute}
            />
          </div>
          <div className="paper-page p-0 lg:pb-4">
            <AvailabilitySummary
              dataRoute={this.state.availabilityRoute}
              spaceGroupsRoute={this.state.spaceGroupsRoute}
              night={this.state.night}
              todayRoute={this.state.todayRoute}
              marinaSlug={this.state.marinaSlug}
              marinaName={this.state.marinaName}
              marinaMcomId={this.state.marinaMcomId}
            />
          </div>
        </div>
      )
    }
  }
}

DashboardController.propTypes = {
  dataRoute: PropTypes.string.isRequired,
}

export default DashboardController
